import { render } from "./DownloadData.vue?vue&type=template&id=5522bc53&scoped=true"
import script from "./_DownloadData.js?vue&type=script&lang=js&external"
export * from "./_DownloadData.js?vue&type=script&lang=js&external"

import "./_DownloadData.less?vue&type=style&index=0&id=5522bc53&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5522bc53"]])

export default __exports__